
import { Component, Mixins, } from "vue-property-decorator";
import { BrowserUtility, BrowserKinds, UuidFactory } from "../../../../utilities";

@Component
export default class AiSyntaxMixin extends Mixins() {
  get syntaxButtonName(): string {
    return "{AI構文}";
  }

  get syntaxButtonDescription(): string {
    return "生成AI構文を設定して現在の入力位置に挿入します。ドラッグ＆ドロップすればドロップした位置に挿入します。";
  }

  get isIe(): boolean {
    return BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer;
  }

  onSyntaxButtonDragStarted(event: DragEvent) {
    event.dataTransfer.effectAllowed = "copy";

    // ドロップ時、一時的に「{AI構文}」を定型文に追加する（{AI構文}が選択状態になる）
    // ダイアログで構文を選択したら{AI構文}を置換、選択しなければ削除する
    // IEでは{AI構文}が選択されていても選択開始位置と終了位置が同じ値になることがあり、
    // {AI構文}を定型文から削除したり構文に置換することができないため、空文字をセットする
    event.dataTransfer.setData(
      "text",
      this.isIe ? "" : this.syntaxButtonName
    );

    if (this.isIe) { return; } // IEはsetDragImageに対応していないため
    this.setDraggingTextImage(event, this.syntaxButtonName);
  }

  setDraggingTextImage(e: DragEvent, text: string): void {
    // ドラッグ中画像専用のElementを一時的に追加してドラッグ終了時に削除する
    const elementId = UuidFactory.create();
    const newElement = document.createElement("span");
    newElement.id = elementId;
    newElement.innerHTML = text;
    newElement.style.position = "absolute";
    newElement.style.left = "-500px";
    newElement.style.top = "-500px";
    document.body.insertBefore(newElement, null);

    e.target.addEventListener(
      "dragend",
      () => {
        const element = document.getElementById(elementId);
        if (element) { document.body.removeChild(element); }
      },
      { once: true },
    );

    e.dataTransfer.setDragImage(newElement, 0, newElement.clientHeight / 2);
  }
}
